module.exports = __webpack_public_path__ + "static/media/vertex_figure_polytope_5_3_52.5518a5b7.png";